export default __webpack_public_path__ + "static/media/clear-filter.6efb73ad.png";